import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Logo: FC<SvgProps> = ({ size = 24, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C13.0064 0 13.9838 0.123878 14.9178 0.357218L5.3256 11.7888C4.6156 12.6349 4.72597 13.8965 5.57212 14.6065C6.41827 15.3165 7.67978 15.2061 8.38978 14.36L18.6744 2.10324C18.6882 2.08673 18.7018 2.07007 18.715 2.05326C21.9038 4.21024 24 7.86032 24 12C24 18.6274 18.6274 24 12 24C11.1923 24 10.4032 23.9202 9.64023 23.7681L18.6343 13.0493C19.3443 12.2031 19.234 10.9416 18.3878 10.2316C17.5417 9.52162 16.2802 9.63198 15.5702 10.4781L5.71424 22.224C2.28561 20.1115 0 16.3227 0 12C0 5.37258 5.37258 0 12 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Logo;
